import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-payment-panel-adyen-paypal',
  templateUrl: './payment-panel-adyen-paypal.component.html',
  standalone: false,
})
export class PaymentPanelAdyenPaypalComponent {
  @Input() clientKey?: string;
  @Input() useTestApi?: boolean;
  @Input() paymentMethodPaypalAvailable = false;
}
